import React from "react";
import {PageHeading} from "peggirkit";
import {generateBreadcrumbs} from "../../../layout/Breadcrumbs";
import {useIntl} from "react-intl";
import router from "@/routing/Router";
import EmployeesPageHeadingActions from "./EmployeesPageHeadingActions";
import {SetURLSearchParams} from "react-router-dom";
import {ClockedFilterStatus} from "@widgets/employees/overview/Employees";
import LocationPageMeta from "@widgets/heading/meta/LocationPageMeta";


type Props = {
    statusFilter: ClockedFilterStatus;
    setSearchParams: SetURLSearchParams;
};

const EmployeesPageHeading = ({statusFilter, setSearchParams}: Props) => {
    const intl = useIntl();
    const route = router.employees;

    return (
        <PageHeading
            breadcrumbs={generateBreadcrumbs(route, intl)}
            title={route.name(intl)}
            actionRow={
                <EmployeesPageHeadingActions
                    statusFilter={statusFilter}
                    setSearchParams={setSearchParams}
                />
            }
            meta={<LocationPageMeta/>}
            actionRowHorizontal={false}
            breakpoints={{md: {actionRowHorizontal: true}}}
        />
    );
};

export default EmployeesPageHeading;